import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { OauthCallback } from '@/pages/auth/oauth-callback'

import { runOAuthCallbackLoader } from './-loader-logic'

const OAuthSearchSchema = z.object({
  code: z.string().optional(),
  state: z.string().optional(),
})

export const Route = createFileRoute('/login/oauth/')({
  component: OauthCallback,
  validateSearch: OAuthSearchSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ deps: { search } }) => runOAuthCallbackLoader(search),
})
